import { z } from 'zod'
import { AREA_SWITCHES, PERMISSION_CATALOG, SWITCH_INFO } from '../constants/permissions.js'
import { grantsSchema } from '../dto/tenant-role.dto.js'
import { tenantRoleReachSchema } from '../enums/tenant-role-reach.enum.js'

/** Grants as an organization admin saves them: every key, and nothing the catalog doesn't know. */
export const grantsInputSchema = grantsSchema.strict()

/** A role as an organization admin saves it, new or changed (docs/custom-roles.spec.md, "Roles"). */
export const tenantRoleInputSchema = z
  .object({
    name: z.string().trim().min(1, 'Give the role a name.').max(60, 'That name is too long.'),
    reach: tenantRoleReachSchema,
    grants: grantsInputSchema,
  })
  .strict()
  .superRefine((input, ctx) => {
    // A switch needs its area at Edit.
    for (const area of PERMISSION_CATALOG) {
      for (const key of AREA_SWITCHES[area.key] ?? []) {
        if (input.grants[key] && input.grants[area.key] !== 'edit') {
          ctx.addIssue({ code: 'custom', message: `${SWITCH_INFO[key].label} needs Edit on ${area.label}.`, path: ['grants', key] })
        }
      }
    }
  })
export type TenantRoleInput = z.infer<typeof tenantRoleInputSchema>
